import { enumBoxStyleSet } from "@coreapp/constants";
import type { QBoxLayout } from "@coreapp/CoreApp/QBoxLayout";

export type BoxStyleEntry = {
  layout: QBoxLayout;
  boxStyleSet: (typeof enumBoxStyleSet)[keyof typeof enumBoxStyleSet];
};

export type EditedOrderId = number | string;

// The box being edited jumps to the top even before it has edits (Figma: selected state).
// Stringify for dedup so a numeric draft id and a string active id don't produce two rows.
export const buildEditedOrder = (
  activeId: EditedOrderId | null | undefined,
  draftOrder: EditedOrderId[]
): EditedOrderId[] => {
  if (activeId == null) return draftOrder;
  return [activeId, ...draftOrder.filter(id => String(id) !== String(activeId))];
};

export const partitionByEditedOrder = (
  sorted: BoxStyleEntry[],
  editedOrder: EditedOrderId[]
): BoxStyleEntry[] => {
  if (editedOrder.length === 0) return sorted;
  // Stringify both sides so a layout reporting "42" still matches editedOrder 42.
  const byId = new Map<string, BoxStyleEntry>();
  for (const entry of sorted) byId.set(String(entry.layout.GetBoxStyleID()), entry);
  const edited: BoxStyleEntry[] = [];
  for (const id of editedOrder) {
    const e = byId.get(String(id));
    if (e) edited.push(e);
  }
  const editedSet = new Set(edited);
  const others = sorted.filter(e => !editedSet.has(e));
  return [...edited, ...others];
};
